import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Import Preview", -1)
const _hoisted_2 = {
  key: 0,
  class: "dropbox p-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Drag CSV here or click to browse", -1)
const _hoisted_4 = {
  key: 1,
  class: "m-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "ID"),
  /*#__PURE__*/_createElementVNode("th", null, "First Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Last Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Email Address")
], -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "text-end me-2" }
const _hoisted_8 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_9 = { class: "text-warning" }
const _hoisted_10 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_11 = { class: "text-warning" }
const _hoisted_12 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_13 = { class: "text-warning" }
const _hoisted_14 = { class: "pe-2" }
const _hoisted_15 = { class: "row ms-2 mt-2 overflow-scroll text-nowrap" }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Failed to import data. See log for details")
], -1)
const _hoisted_18 = { class: "row" }
const _hoisted_19 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}

import ModalView from "@/components/ModalView.vue";
import { computed, ref, Ref, watch } from "vue";
import { ValidationType } from "@/model/organisation";
import * as Papa from "papaparse";
import { ParseResults, ParseError } from "@/utilties/papa-parser";
import TableView from "@/components/TableView.vue";
import { Employee } from "@/model/employee";
import { AccessCode } from "@/utilties/access-code-gen";
import { ApiService } from "@/api-service";
import { getFunctions } from "firebase/functions";


export default /*#__PURE__*/_defineComponent({
  props: {
    existingEmployees: null,
    isVisible: { type: Boolean },
    validationType: null,
    organisationId: null
  },
  emits: ["hide-modal"],
  setup(__props: any, { emit }) {

const props = __props as {
  existingEmployees: Employee[];
  isVisible: boolean;
  validationType: ValidationType;
  organisationId: string;
}

let loading: Ref<boolean> = ref(false);



const fileInput: Ref<HTMLInputElement | null> = ref(null);

const parsedEmployees: Ref<Employee[]> = ref([]);
const parsedEmployeesSample = computed<Employee[]>(() =>
  parsedEmployees.value.slice(0, 10)
);

const employeesToImport: Ref<Employee[]> = ref([]);
const duplicateEmployees: Ref<Employee[]> = ref([]);
const invalidEmployees: Ref<Employee[]> = ref([]);

const hasParsedCsv = ref(false);

const parseErrors: Ref<ParseError[]> = ref([]);
const parseErrorsSample = computed<ParseError[]>(() =>
  parseErrors.value.slice(0, 5)
);

const apiError: Ref<Error | null> = ref(null);

const apiService = new ApiService(getFunctions());



function importCsv() {
  const file: File = fileInput.value!.files!.item(0)!;
  Papa.parse(file, {
    header: true,
    quotes: true,
    complete: (results: ParseResults) => {
      hasParsedCsv.value = true;
      parseErrors.value = results.errors;
      parsedEmployees.value = results.data
        .filter((data, index) => {
          return !results.errors.map((error) => error.row).includes(index);
        })
        .map((data) => {
          let id: string | null = null;
          switch (props.validationType) {
            case ValidationType.email:
              id = data.emailAddress;
              break;
            case ValidationType.idCode:
              if (data.accessCode == null || data.accessCode == "") {
                id = AccessCode.generate(6);
              } else {
                id = data.accessCode;
              }
              break;
          }

          return new Employee(
            id,
            data.firstName,
            data.lastName,
            data.emailAddress,
            true
          );
        });

      const uniqueEmployees = parsedEmployees.value.filter((employee) => {
        return !props.existingEmployees
          .map((existingEmployee) => existingEmployee.id)
          .includes(employee.id);
      });

      employeesToImport.value = uniqueEmployees.filter((employee) => {
        return employee.id != null && employee.id != "";
      });

      duplicateEmployees.value = parsedEmployees.value.filter((employee) => {
        return props.existingEmployees
          .map((existingEmployee) => existingEmployee.id)
          .includes(employee.id);
      });

      invalidEmployees.value = uniqueEmployees.filter((employee) => {
        return employee.id == null || employee.id == "";
      });
    },
  });
}

async function importEmployees() {
  loading.value = true;

  if (employeesToImport.value.length == 0) {
    console.log("No employees to import");
  } else {
    await apiService
      .createEmployees(props.organisationId, employeesToImport.value)
      .then(() => {
        emit("hide-modal");
      })
      .catch((error) => {
        console.log("importEmployees failed", error);
      });
  }

  loading.value = false;
}

watch(
  () => props.isVisible,
  (visible: boolean) => {
    if (visible) {
      parsedEmployees.value = [];
      employeesToImport.value = [];
      duplicateEmployees.value = [];
      invalidEmployees.value = [];
      parseErrors.value = [];
      hasParsedCsv.value = false;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalView, {
    "is-visible": __props.isVisible,
    large: true,
    onHideModal: _cache[2] || (_cache[2] = ($event: any) => (emit('hide-modal')))
  }, {
    header: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn-close", { disabled: _unref(loading) }]),
        "data-bs-dismiss": "modal",
        "aria-label": "Close"
      }, null, 2)
    ]),
    body: _withCtx(() => [
      (!hasParsedCsv.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("input", {
              type: "file",
              name: "Upload things",
              onChange: _cache[0] || (_cache[0] = ($event: any) => (importCsv())),
              accept: "text/csv",
              class: "input-file",
              ref_key: "fileInput",
              ref: fileInput
            }, null, 544),
            _hoisted_3
          ]))
        : (apiError.value == null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(TableView, { responsive: true }, {
                header: _withCtx(() => [
                  _hoisted_5
                ]),
                body: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(parsedEmployeesSample), (employee) => {
                    return (_openBlock(), _createElementBlock("tr", { key: employee }, [
                      _createElementVNode("td", null, _toDisplayString(employee.id), 1),
                      _createElementVNode("td", null, _toDisplayString(employee.firstName), 1),
                      _createElementVNode("td", null, _toDisplayString(employee.lastName), 1),
                      _createElementVNode("td", null, _toDisplayString(employee.emailAddress), 1)
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, "Showing first " + _toDisplayString(_unref(parsedEmployeesSample).length) + " of " + _toDisplayString(parsedEmployees.value.length) + " entries", 1)
              ]),
              (duplicateEmployees.value.length !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(duplicateEmployees.value.length) + " duplicate entries ", 1)
                  ]))
                : _createCommentVNode("", true),
              (invalidEmployees.value.length !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(invalidEmployees.value.length) + " invalid entries (missing ID) ", 1)
                  ]))
                : _createCommentVNode("", true),
              (parseErrors.value.length !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(parseErrors.value.length) + " lines failed to parse (showing " + _toDisplayString(_unref(parseErrorsSample).length) + " of " + _toDisplayString(parseErrors.value.length) + ") ", 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(parseErrorsSample), (error) => {
                    return (_openBlock(), _createElementBlock("code", { key: error }, " Line " + _toDisplayString(error.row) + " | " + _toDisplayString(error.message), 1))
                  }), 128))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", null, _toDisplayString(apiError.value.details), 1)
              ])
            ]))
    ]),
    footer: _withCtx(() => [
      (apiError.value == null)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: _normalizeClass(["btn btn-primary", { disabled: _unref(loading) || employeesToImport.value.length === 0 }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (importEmployees()))
          }, [
            (_unref(loading))
              ? (_openBlock(), _createElementBlock("span", _hoisted_19))
              : _createCommentVNode("", true),
            _createTextVNode(" Import " + _toDisplayString(employeesToImport.value.length) + " Employees ", 1)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})